import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaEnvelope,
  FaGlobe,
  FaArrowUp,
  FaChevronRight,
  FaShieldAlt,
  FaBolt,
} from "react-icons/fa";
import { Link, animateScroll as scroll } from "react-scroll";
import logo from "../../assest/logo.png";

const Footer = () => {
  const scrollToTop = () => {
    scroll.scrollToTop({ duration: 600, smooth: "easeInOutQuart" });
  };

  return (
    <footer className="relative bg-[#FFFBF5] text-[#3D2E22] border-t border-[#F5DFC5] overflow-hidden pt-16 pb-8">
      {/* Ambient background glow & radial gradient */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 left-1/4 w-[600px] h-[300px] opacity-[0.45] blur-[120px]"
        style={{
          background:
            "radial-gradient(circle, #FEF3E5 0%, #FFF4E5 50%, transparent 70%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 right-10 w-[400px] h-[300px] opacity-[0.35] blur-[100px]"
        style={{
          background: "radial-gradient(circle, #FDE8CD 0%, transparent 70%)",
        }}
      />

      <div className="container mx-auto px-4 sm:px-6 lg:px-12 max-w-7xl relative z-10">
        {/* ================= TOP CTA / NEWSLETTER BADGE ================= */}
        <div className="mb-14 pb-8 lg:pb-10 border-b border-[#F0DCC8] flex flex-col lg:flex-row items-center justify-between gap-6 bg-gradient-to-r from-[#FEF3E5] via-[#FFFBF5] to-[#FEF3E5] p-6 sm:p-8 rounded-3xl border border-[#FDE8CD] shadow-[0_15px_40px_-15px_rgba(217,119,6,0.12)]">
          <div className="flex items-center gap-4 text-left">
            <div className="w-12 h-12 rounded-2xl bg-white border border-[#FDE8CD] text-[#D97706] flex items-center justify-center text-xl shrink-0 shadow-sm">
              <FaBolt />
            </div>
            <div>
              <h3
                className="text-lg sm:text-xl font-bold text-[#1C1410] tracking-tight"
                style={{ fontFamily: "'Fraunces', serif" }}
              >
                Boost your website RPM with Myad360
              </h3>
              <p className="text-xs sm:text-sm text-[#4D3E30] mt-1">
                Access Google AdX, header bidding demand, and real-time revenue analytics today.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 w-full lg:w-auto">
            <a
              href="#contactID"
              className="w-full lg:w-auto inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#D97706] to-[#EA580C] hover:from-[#EA580C] hover:to-[#D97706] text-white font-extrabold text-xs sm:text-sm px-6 py-3.5 rounded-full shadow-[0_10px_25px_-5px_rgba(217,119,6,0.35)] transition-all duration-300 hover:-translate-y-0.5"
            >
              <span>Get Started Free</span>
              <FaChevronRight className="text-xs" />
            </a>
          </div>
        </div>

        {/* ================= MAIN 4-COLUMN FOOTER GRID ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-14">
          {/* Col 1: Brand & Bio */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <img
                width={150}
                src={logo}
                alt="MyAd360 Logo"
                className="h-auto object-contain"
              />
            </div>
            <p className="text-xs sm:text-sm leading-relaxed text-[#4D3E30]">
              Myad360 is an enterprise ad monetization platform helping global publishers maximize ad revenue through Google AdX, header bidding, and AI optimization.
            </p>

            <div className="flex items-center gap-2.5 pt-2">
              {[
                { icon: <FaFacebookF />, href: "#", label: "Facebook" },
                { icon: <FaInstagram />, href: "#", label: "Instagram" },
                { icon: <FaTwitter />, href: "#", label: "Twitter" },
                { icon: <FaLinkedinIn />, href: "#", label: "LinkedIn" },
                { icon: <FaWhatsapp />, href: "#", label: "WhatsApp" },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  aria-label={item.label}
                  className="w-9 h-9 rounded-full bg-white border border-[#F0DCC8] text-[#D97706] hover:bg-[#D97706] hover:text-white hover:border-[#D97706] flex items-center justify-center transition-all duration-300 shadow-sm text-xs"
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Col 2: Useful Links */}
          <div>
            <h4
              className="text-base font-bold text-[#1C1410] mb-5 uppercase tracking-wider text-xs"
              style={{ fontFamily: "'Fraunces', serif" }}
            >
              Useful Links
            </h4>
            <ul className="space-y-3 text-xs sm:text-sm">
              {[
                { name: "Home", to: "homeID", offset: -20 },
                { name: "About Us", to: "aboutID", offset: -70 },
                { name: "Services", to: "servicesID", offset: -30 },
                { name: "Our Features", to: "featuresID", offset: -35 },
                { name: "Our Vision", to: "ourVisionID", offset: -70 },
                { name: "Latest Blog", to: "blogID", offset: -70 },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    smooth={true}
                    duration={500}
                    offset={link.offset}
                    className="inline-flex items-center gap-2 text-[#4D3E30] hover:text-[#D97706] transition-colors duration-200 cursor-pointer group font-medium"
                  >
                    <FaChevronRight className="text-[10px] text-[#D97706] group-hover:translate-x-1 transition-transform" />
                    <span>{link.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Services */}
          <div>
            <h4
              className="text-base font-bold text-[#1C1410] mb-5 uppercase tracking-wider text-xs"
              style={{ fontFamily: "'Fraunces', serif" }}
            >
              Monetization Solutions
            </h4>
            <ul className="space-y-3 text-xs sm:text-sm">
              {[
                "Google AdX Management",
                "Header Bidding Integration",
                "Dynamic Ad Layouts",
                "In-Stream Video Ads",
                "Pre-Violation Shielding",
                "Custom Player & Plugins",
              ].map((service) => (
                <li key={service} className="flex items-center gap-2 text-[#4D3E30] hover:text-[#D97706] transition-colors duration-200 cursor-pointer group font-medium">
                  <FaChevronRight className="text-[10px] text-[#D97706] group-hover:translate-x-1 transition-transform" />
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact & Platform Security */}
          <div className="space-y-4">
            <h4
              className="text-base font-bold text-[#1C1410] mb-5 uppercase tracking-wider text-xs"
              style={{ fontFamily: "'Fraunces', serif" }}
            >
              Get In Touch
            </h4>

            <div className="space-y-3 text-xs sm:text-sm">
              <div className="flex items-center gap-3 text-[#4D3E30] font-medium">
                <div className="w-8 h-8 rounded-lg bg-white border border-[#F0DCC8] flex items-center justify-center text-[#D97706] shrink-0 shadow-sm">
                  <FaEnvelope />
                </div>
                <span>support@myad360.com</span>
              </div>
              <div className="flex items-center gap-3 text-[#4D3E30] font-medium">
                <div className="w-8 h-8 rounded-lg bg-white border border-[#F0DCC8] flex items-center justify-center text-[#D97706] shrink-0 shadow-sm">
                  <FaGlobe />
                </div>
                <span>Worldwide Publisher Coverage</span>
              </div>
            </div>

            <div className="pt-3">
              <div className="p-3.5 rounded-2xl bg-white border border-[#FDE8CD] shadow-sm flex items-center gap-3">
                <FaShieldAlt className="text-xl text-[#D97706] shrink-0" />
                <div className="text-[11px]">
                  <p className="font-bold text-[#1C1410]">Forensiq &amp; Sherlock Verified</p>
                  <p className="text-[#6B5644]">100% Brand Safe Demand</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= BOTTOM COPYRIGHT BAR ================= */}
        <div className="pt-8 border-t border-[#F0DCC8] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#6B5644]">
          <p>
            © {new Date().getFullYear()}{" "}
            <span className="text-[#1C1410] font-bold">Myad360</span>. All rights reserved. Built for high-yield publishers worldwide.
          </p>

          <div className="flex items-center gap-6 font-medium">
            <span className="hover:text-[#D97706] cursor-pointer transition-colors">Privacy Policy</span>
            <span className="hover:text-[#D97706] cursor-pointer transition-colors">Terms of Service</span>
            <button
              onClick={scrollToTop}
              className="w-9 h-9 rounded-full bg-white border border-[#F0DCC8] text-[#D97706] hover:bg-[#D97706] hover:text-white flex items-center justify-center transition-all duration-300 shadow-sm"
              aria-label="Back to top"
            >
              <FaArrowUp className="text-xs" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
